import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxldoc/list", params, successCallback, failCallback, exceptionCallback);
	}, merge : (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consuxldoc/merge", params, successCallback, failCallback, exceptionCallback);
	} ,leadTo: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consuxldoc/leadTo", params, successCallback, failCallback, exceptionCallback);
	} 
}

export default api;
